import { Stack, Typography } from "@mui/material"

interface DashboardCardProps {
  backgroundColor: string;
  title: string;
  value: string;
}

export const DashboardCard = ({backgroundColor, title, value}: DashboardCardProps) => {
  return (
    <Stack
      width='100%' 
      borderRadius='16px' 
      padding={2} 
      boxShadow={`0px 4px 4px 0px #00000040`}
      sx={{ background: backgroundColor }}
      spacing={3}
    >
      <Typography textAlign="center" variant="h5" fontWeight="600" fontFamily="korolev-condensed">{title}</Typography>
      <Typography textAlign="center" variant="h2" fontWeight="900" fontFamily="korolev-condensed">{value}</Typography>
    </Stack>
  )
}